import { Controller } from "@hotwired/stimulus";

// Keeps the read-only "Price at this location" table in sync with the "Products sold here" multiselect, so a row
// appears the moment its product is selected and disappears when it's deselected — before the edit is saved. Prices
// are fixed server data (each product's resolved price at this location), so unlike the product page's price-by-location
// table there's nothing to recompute; this only toggles which rows are visible. A newly-added product Nexus hasn't
// priced here yet shows "—" until the edit is saved. Wired on the location form, which catches the multiselect's
// bubbling "change".
export default class extends Controller {
  static targets = ["row", "empty", "table"];

  connect() {
    this.syncVisibility();
  }

  syncVisibility() {
    const selected = this.selectedProductIds();
    let anyVisible = false;
    this.rowTargets.forEach((row) => {
      const show = selected.has(row.dataset.productId);
      row.classList.toggle("hidden", !show);
      anyVisible ||= show;
    });
    if (this.hasTableTarget) this.tableTarget.classList.toggle("hidden", !anyVisible);
    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("hidden", anyVisible);
  }

  selectedProductIds() {
    return new Set(
      Array.from(this.element.querySelectorAll('input[name="record[product_ids][]"]'))
        .map((input) => input.value)
        .filter((value) => value !== "")
    );
  }
}
